import { extend } from "vee-validate";

const installRules = function (rules: { [key: string]: any }) {
  Object.keys(rules).forEach((rule) => {
    extend(rule, rules[rule]);
  });
};

export default installRules;
